(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBasicVideoSlider(sectionEl) {
      if (!sectionEl) return;
      const swiperEl = sectionEl.querySelector('.basic-swiper');
      if (!swiperEl) return;

      // Config uit data-attributen
      const perViewMobile = Number(sectionEl.dataset.mobile) || 1;
      const perViewTablet = Number(sectionEl.dataset.tablet) || 2;
      const perViewDesktop = Number(sectionEl.dataset.desktop) || 3;
      const spaceBetween = Number(sectionEl.dataset.space) || 12;

      function ensureSwiper(cb) {
        if (window.Swiper) return cb();
        const s = document.createElement('script');
        s.src = 'https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js';
        s.onload = cb;
        s.onerror = () => console.error('[Basic Slider] Swiper JS CDN failed to load');
        document.head.appendChild(s);
      }

      function loadVideo(videoEl) {
        if (!videoEl || videoEl.src) return;
        const src = videoEl.getAttribute('data-video-src');
        if (src) {
          videoEl.src = src;
          videoEl.load();
          videoEl.play().catch(() => {});
        }
      }

      function getActiveSlidesPerView(swiper) {
        const windowWidth = window.innerWidth;
        if (windowWidth >= 1024) return perViewDesktop;
        if (windowWidth >= 768) return perViewTablet;
        return perViewMobile;
      }

      ensureSwiper(() => {
        // Dubbele init voorkomen
        if (swiperEl.__basicSwiper) {
          swiperEl.__basicSwiper.destroy(true, true);
          swiperEl.__basicSwiper = null;
        }

        const navNext = sectionEl.querySelector('.swiper-button-next') || null;
        const navPrev = sectionEl.querySelector('.swiper-button-prev') || null;

        const config = {
          slidesPerView: perViewMobile,
          spaceBetween: spaceBetween,
          breakpoints: {
            768: { slidesPerView: perViewTablet },
            1024: { slidesPerView: perViewDesktop }
          },
          on: {
            init: function(swiper) {
              // Laad initiële zichtbare video's + 1 extra
              const currentPerView = getActiveSlidesPerView(swiper);
              const videosToLoad = Math.ceil(currentPerView) + 1;
              
              for (let i = 0; i < videosToLoad && i < swiper.slides.length; i++) {
                const video = swiper.slides[i].querySelector('video[data-video-src]');
                if (video) loadVideo(video);
              }
            },
            slideChange: function(swiper) {
              // Laad huidige zichtbare video's + 1 volgende
              const currentIndex = swiper.activeIndex;
              const currentPerView = getActiveSlidesPerView(swiper);
              const videosToLoad = Math.ceil(currentPerView) + 1;
              
              for (let i = 0; i < videosToLoad; i++) {
                const slideIndex = currentIndex + i;
                if (slideIndex < swiper.slides.length) {
                  const video = swiper.slides[slideIndex].querySelector('video[data-video-src]');
                  if (video) loadVideo(video);
                }
              }
            }
          }
        };

        // Alleen navigation opnemen als pijlen bestaan (show_arrows = true)
        if (navNext && navPrev) {
          config.navigation = { nextEl: navNext, prevEl: navPrev };
        }

        const swiper = new Swiper(swiperEl, config);
        swiperEl.__basicSwiper = swiper;
      });
    }

    // Vind de juiste sectie voor dit script
    function getSectionElFromScript(scriptEl) {
      let el = scriptEl.closest('[data-section-id]');
      if (el) return el;
      const all = document.querySelectorAll('.basic-video-slider[data-section-id]');
      return all[all.length - 1] || null;
    }

    function initFromScript(scriptEl) {
      const sectionEl = getSectionElFromScript(scriptEl);
      if (!sectionEl) return;
      initBasicVideoSlider(sectionEl);
    }

    // Init bij load
    if (document.currentScript) {
      initFromScript(document.currentScript);
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.basic-video-slider[data-section-id]').forEach(initBasicVideoSlider);
      });
    }

    // Re-init bij Theme Editor
    document.addEventListener('shopify:section:load', (e) => {
      const root = e.target?.querySelector?.('.basic-video-slider[data-section-id]') || e.target;
      if (root?.matches?.('.basic-video-slider[data-section-id]')) initBasicVideoSlider(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
